//import axios from 'axios';
import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getAllClinics = ()=>{
    return axios.get(API_URL+"clinics");
}
const getAllClinicsFast = ()=>{
    return axios.get(API_URL+"template-clinics");
}

const getClinicById=(id)=>{
    return axios.get(API_URL+"clinics/"+id);
}
const addClinic=({name,email,phone,sms,logo,signature,website,assetName})=>{
    return axios
    .post(API_URL+"clinics",{
        name,
        email,
        phone,
        sms,
        logo,
        signature,
        website,
        assetName
    })
   
}
const updateClinic=(id,data)=>{
    
    //console.log(data)
    return axios
    .put(API_URL+"clinics/"+id,data)
    
}

const getAllTimeZones=()=>{
    return axios.get(API_URL+"timezones");
}
const updateTimezone=(id,data)=>{
   
    return axios.post(API_URL+"clinics/"+id+"/timezone/"+data.timezoneid)
}
const getTimeZone = (id)=>{
    return axios.get(API_URL+"clinics/"+id+"/timezone");
}
const getAddress = (id)=>{
    return axios.get(API_URL+"clinics/"+id+"/address");
}
const updateAddress=(id,data)=>{
    return axios.put(API_URL+"clinics/"+id+"/address",data);
}
const addAddress = (id,data) =>{
    return axios.post(API_URL+"clinics/"+id+"/address",data);
}
const getHours = (id)=>{
    return axios.get(API_URL+"clinics/"+id+"/hours");
}
const updateHours =(id,data)=>{
    return axios
    .post(API_URL+"clinics/"+id+"/hours",data);
}
const deleteHours = (id,data)=>{
    return axios
    .delete(API_URL+"clinics/"+id+"/hours",{data:data});
}

const getSettings=(id)=>{
    return axios.get(API_URL+"clinics/"+id+"/features")
}
const updateSettings=(id,data)=>{
    return axios.put(API_URL+"clinics/"+id+"/features",data)
}


const getUpdates = (id)=>{
    return axios.get(API_URL+"clinics/"+id+"/updates");
}
const getVerification =(id)=>{
    return axios.get(API_URL+"clinics/"+id+"/verification");
}
const updateVerification=(id,data)=>{
    return axios
    .put(API_URL+"clinics/"+id+"/verifications",data)
}
const sendVerification=(id,data) =>{
    return axios
    .get(API_URL+"clinics/"+id+"/verifications?type="+data);
}
const getReminderSettings=(id)=>{
    return axios.get(API_URL+"clinics/"+id+"/reminder-settings");
}
const updateReminderSettings=(id,data)=>{
    return axios
    .put(API_URL+"clinics/"+id+"/reminder-settings",data)
}
const addAuth=(id,data)=>{
    return axios
    .post(API_URL+"users/"+id+"/auth",data)
}

const getUserAuth=(id)=>{
    return axios 
    .get(API_URL+"users/"+id+"/auth")
}
const updateUserAuth=(id,data)=>{
    return axios
    .put(API_URL+"users/"+id+"/auth",data)
}

const getCustomization = (clinicid) =>{
    return axios
    .get(API_URL+"clinics/"+clinicid+"/customizes")
}
const updateCustomization = (clinicid,data)=>{
    return axios
    .post(API_URL+"clinics/"+clinicid+"/customizes",data)
}
const deleteCustomization = (clinicid, customid)=>{
    return axios
    .delete(API_URL+"clinics/"+clinicid+"/customizes/"+customid)
}
const getSocialLinks = (clinicid)=>{
    console.log("Social Links url : "+API_URL+"clinics/"+clinicid+"/social-links")
    return axios.get(API_URL+"clinics/"+clinicid+"/social-links")
}
const updateSocialLinks = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/social-links",data)
}
const deleteSocialLink = (clinicid,linkid) =>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/social-links/"+linkid)
}
const getLens = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/cl-brands")
}
const addUpdateLens = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/cl-brands",data)
}
const deleteLens = (clinicid,id)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/cl-brands/"+id)
}
const getMedia = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/resources")
}
const deleteMedia=(clinicid,data)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/resources",{data:data})
}
const uploadMedia=(clinicid,formData,uploadProgress)=>{
       return axios.post(API_URL+"clinics/"+clinicid+"/resources",formData,{
        headers:{
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: uploadProgress,
       })
}
//Reputation
const getReputationClinic = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/reputation-enhancements")
}
const getReputationLinks = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/reputation-enhancements/links")
}
const getReputationFeedbacks = (clinicid,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/reputation-enhancements/feedbacks?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getReputationComments = (clinicid,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/reputation-enhancements/comments?pageNo="+pageNo+"&pageSize="+pageSize)
}
const addReputationClinic = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/reputation-enhancements",data)
}
const addUpdateReputationLink = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/reputation-enhancements/links",data)
}
const deleteReputationLink = (clinicid,linkid)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/reputation-enhancements/links/"+linkid)
}
//Hostory
const getHistory = (clinicid,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/update-history?pageNo="+pageNo+"&pageSize="+pageSize)
}
//stats
const getPatientStats=(clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/patient-stats")
}
//assets
const getAssets = (clinicid) =>{
    return axios.get(API_URL+"clinics/"+clinicid+"/assets")
}
const saveAssets = (clinicid,data) =>{
    return axios.post(API_URL+"clinics/"+clinicid+"/assets",data)
}
const getUsers = (id)=>{
    return axios.get(API_URL+"clinics/"+id+"/users");
}
export default {
    getAllClinics,
    getAllClinicsFast,
    getClinicById,
    addClinic,
    updateClinic,
    getAllTimeZones,
    getTimeZone,
    updateTimezone,
    getAddress,
    updateAddress,
    addAddress,
    getHours,
    updateHours,
    deleteHours,
    getSettings,
    updateSettings,
    getUpdates,
    getVerification,
    updateVerification,
    sendVerification,
    getReminderSettings,
    updateReminderSettings,
    addAuth,
    getUserAuth,
    updateUserAuth,
    getCustomization,
    updateCustomization,
    deleteCustomization,
    getSocialLinks,
    updateSocialLinks,
    deleteSocialLink,
    getLens,
    addUpdateLens,
    deleteLens,
    getMedia,
    deleteMedia,
    uploadMedia,
    getReputationClinic,
    getReputationLinks,
    getReputationFeedbacks,
    getReputationComments,
    addReputationClinic,
    addUpdateReputationLink,
    deleteReputationLink,
    getHistory,
    getPatientStats,
    getAssets,
    saveAssets,
    getUsers
}